'use strict';

import $ from 'jquery';

function ReviewMoodControl(elem) {
    // Getting api url and review id

    const {apiUrl, review} = elem.dataset;

    if (!apiUrl && !review)
        return false;

    // Getting like and dislike buttons

    const buttons = {
        like: elem.querySelector('button[data-mood="like"]'),
        dislike: elem.querySelector('button[data-mood="dislike"]')
    };

    if ((Object.values(buttons)).includes(null))
        return false;

    Object.freeze(buttons);

    // Defining getter of active like or dislike

    const getActive = () => (
        (buttons.like).classList.contains('active') && 'like'
    ) || (
        (buttons.dislike).classList.contains('active') && 'dislike'
    );

    // Getting text elements with counts of buttons

    const selectorText = '.review__voting-item-text, .reviews-voting-button-count';

    const texts = {
        like: (buttons.like).querySelector(selectorText),
        dislike: (buttons.dislike).querySelector(selectorText)
    };

    if ((Object.values(texts)).includes(null))
        return false;

    Object.freeze(texts);

    // Getting counts from text elements

    let counts = {
        like: Number((texts.like).innerText),
        dislike: Number((texts.dislike).innerText)
    }

    if ((Object.values(counts)).includes(NaN))
        return false;

    counts = new Proxy(counts, {
        set: (obj, prop, value) => {
            (this.texts[prop]).innerText = value;
            obj[prop] = value;
            return true;
        }
    });

    Object.seal(counts);

    // Assigning data to constructor

    Object.assign(this, {apiUrl, review, buttons, getActive, texts, counts});

    return Object.freeze(this);
}

ReviewMoodControl.prototype.handleMood = function (mood) {
    const {apiUrl: url, review: REVIEW_ID, getActive, buttons, counts} = this;
    const active = getActive();
    const isUnsetting = active === mood;
    const postOpts = {
        url,
        data: {
            REVIEW_ID,
            MOOD: isUnsetting ? 'unset' : mood
        },
        dataType: 'json'
    };

    $.post(postOpts)
        .done(({status}) => {
            if (status === true) {
                if (active !== false) {
                    buttons[active].classList.remove('active');
                    counts[active]--;
                }

                if (isUnsetting)
                    return false;

                buttons[mood].classList.add('active');
                counts[mood]++;
            }
        });
};

ReviewMoodControl.prototype.like = function () {
    this.handleMood('like');
};

ReviewMoodControl.prototype.dislike = function () {
    this.handleMood('dislike');
};

ReviewMoodControl.prototype.clickHandler = function (event) {
    const {mood} = event.currentTarget.dataset;
    this.handleMood(mood);
};

ReviewMoodControl.prototype.bindEvents = function () {
    if (this.buttons) {
        (Object.values(this.buttons)).forEach((button) => {
            button.addEventListener('click', (this.clickHandler).bind(this));
        });
    }
};

const moodControls = document.querySelectorAll('.review__voting');
moodControls.forEach((controlElem) => new ReviewMoodControl(controlElem).bindEvents());

export default ReviewMoodControl;
